module.exports = __webpack_public_path__ + "img/metal-gear-solid.3ad81b8d.png";